import { Component, OnInit } from '@angular/core';
import { TranslateService } from "@ngx-translate/core/lib/translate.service";
import { IOAuthService } from 'src/app/_Services/user/iOAuthService';
@Component({
  selector: 'app-forbidden',
  templateUrl: './forbidden.component.html',
  styleUrls: ['./forbidden.component.scss']
})
export class ForbiddenComponent {

  title: string;
  message: string;
  public _image: string;
  public translate: TranslateService;
  constructor(private oAuthService: IOAuthService) {
     this._image = "assets/images/went-wrong.svg";
  }

  async logout(){
    await this.oAuthService.logOut();
  }
}
